import { render, staticRenderFns } from "./DetentionCenter.vue?vue&type=template&id=c388ffa0&scoped=true&"
import script from "./DetentionCenter.vue?vue&type=script&lang=js&"
export * from "./DetentionCenter.vue?vue&type=script&lang=js&"
import style0 from "./DetentionCenter.vue?vue&type=style&index=0&id=c388ffa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c388ffa0",
  null
  
)

export default component.exports